module.exports = __webpack_public_path__ + "static/pic05-9ab75e134d1a9275afcc821574cd23b1.png";